export const ENDPOINTS = {
  list: 'countries/get-list',
};
